import gql from "graphql-tag";

export const ALL_CUSTOMER_ORDERS = gql`
    query ALL_CUSTOMER_ORDERS($page: Int!, $perPage: Int!, $searchKeyword: String, $orderCustomers:[String],$orderStatus: [String], $orderPayment:[Int], $deliveryDates: [Date], $isFuture: Boolean ){
        orders (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, customers: $orderCustomers, status: $orderStatus, payment:$orderPayment, deliveryDates: $deliveryDates, isFuture: $isFuture) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                customer {
                    name,
                    customerCode
                    institutionId{
                        name,
                    }
                },
                orderItems {
                    publicId
                    item {
                        productName
                    },
                    itemCount,
                    itemPieces
                }
                orderedBy,
                createdAt
                deliveryDate,
                invoiceId,
                grossOrderTotal,
                status {
                    publicId,
                    orderStatusName
                }
            }
        }
    }
`;

export const ALL_CUSTOMER_ORDERS_DELIVERIES = gql`
    query ALL_CUSTOMER_ORDERS_DELIVERIES($page: Int!, $perPage: Int!, $searchKeyword: String, $orderCustomers:[String],$orderStatus: [String], $orderPayment:[Int], $deliveryDates: [Date], $isFuture: Boolean ){
        orders (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, customers: $orderCustomers, status: $orderStatus, payment:$orderPayment, deliveryDates: $deliveryDates, isFuture: $isFuture) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                customer {
                    publicId,
                    name,
                    customerCode,
                    lat,
                    longi
                },
                invoiceId,
                createdAt,
                deliveryDate,
                timezone {
                    publicId,
                    timezoneName
                },
                status {
                    publicId,
                    orderStatusName
                },
                canCancelOrder
                
                
            }
        }
    }
`;

export const ALL_ORDER_DELIVERIES = gql`
    query ALL_ORDER_DELIVERIES($page: Int!, $perPage: Int!, $searchKeyword: String, $orderStatus: [String], $deliveryTimezones: [String], $deliveryDates: [Date], $warehouse: String, $institutionTypes: [String]){
        deliveries (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, status: $orderStatus, deliveryTimezones:$deliveryTimezones, deliveryDates: $deliveryDates, warehouse: $warehouse, institutionTypes: $institutionTypes) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                customer {
                    publicId,
                    name,
                    customerCode,
                    lat,
                    longi
                },
                invoiceId,
                createdAt,
                deliveryDate,
                timezone {
                    publicId,
                    timezoneName
                },
                status {
                    publicId,
                    orderStatusName
                },
                canCancelOrder
                
                
            }
        }
    }
`;

export const ALL_CUSTOMER_ORDERS_FINANCE = gql`
    query ALL_CUSTOMER_ORDERS_FINANCE($page: Int!, $perPage: Int!, $searchKeyword: String, $orderCustomers:[String],$orderStatus: [String], $orderPayment:[Int], $deliveryDates: [Date], $isFuture: Boolean, $paymentDue: Int, $isDeposited: Int, $paymentMethods: [String] ){
        orders (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, customers: $orderCustomers, status: $orderStatus, payment:$orderPayment, deliveryDates: $deliveryDates, isFuture: $isFuture, paymentDue: $paymentDue, isDeposited: $isDeposited, paymentMethods: $paymentMethods) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                customer {
                    publicId,
                    name,
                    customerCode
                },
                invoiceId,
                createdAt,
                deliveryDate,
                paymentDueDate
                paymentReceivedDate
                isPaymentOverdue
                orderBalanceDue
                status {
                    publicId,
                    orderStatusName
                },
                paymentStatus {
                    id,
                    name
                },
                grossOrderTotal
                depositDetails {
                    createdAt
                },
                paymentDetails {
                    paymentType {
                        paymentMethodName
                    },
                    paymentRef,
                    createdAt
                },


            }
        }
    }
`;

export const ALL_CUSTOMER_ORDERS_SHORTENED = gql`
    query ALL_CUSTOMER_ORDERS_SHORTENED($page: Int!, $perPage: Int!, $searchKeyword: String, $orderCustomers:[String],$orderStatus: [String], $orderPayment:[Int], $deliveryDates: [Date], $isFuture: Boolean ){
        orders (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, customers: $orderCustomers, status: $orderStatus, payment:$orderPayment, deliveryDates: $deliveryDates, isFuture: $isFuture) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                customer {
                    name,
                },
                invoiceId,
                deliveryDate,
                paymentDueDate
                statementGenDate
            }
        }
    }
`;

export const SINGLE_CUSTOMER_ORDER = gql`
    query SINGLE_CUSTOMER_ORDER($id: String!){
        order (id: $id) {
            publicId,
            customer {
                publicId,
                name,
                customerCode,
                addressLine1
                street
                institutionId {
                    name,
                    pin,
                    postalCode,
                    institutionCode,
                    phoneNumber,
                }
                validOrderDays {
                    weekday
                },
                validOrderProducts {
                    publicId,
                    productName
                }
            },
            orderedBy,
            timezone {
                publicId,
                timezoneName
            },
            deliveryDate,
            lpo,
            invoiceId,
            surchargePercentage,
            orderSurchargeAmount,
            grossOrderTotal,
            netOrderTotal,
            orderVat,
            vatRate,
            isDiscountApplied,
            orderDiscount,
            status {
                publicId,
                orderStatusName
                isOrderCompleteStatus,
                isOrderCancelledStatus,
            },
            paymentStatus {
                id,
                name
            },
            isPaymentOverdue,
            paymentDueDate,
            paymentReceivedDate,
            orderItems {
                publicId,
                item {
                    publicId,
                    productName,
                    qpoUnit
                    shipments {
                        publicId,
                        orderId,
                        expiryDate,
                        warehouseId {
                            publicId,
                            name
                        },
                    },
                },
                itemCount,
                itemPrice,
                isDiscountApplied,
                itemDiscountRecord {
                    publicId,
                    orderItemDiscountAmount,
                    orderItemDiscountPercentage,
                    createdAt,
                    updatedAt
                },
                itemDiscount,
                grossItemTotal,
                netItemTotal,
                itemVat,
                warehouse {
                    publicId,
                    name
                },
                shipments {
                    publicId,
                    orderId
                },
                availableStatusChanges {
                    publicId,
                    orderStatusName
                },
                status {
                    publicId,
                    orderStatusName
                }
            },
            createdAt,
            updatedAt,
            orderDiscountRecord {
                publicId,
                orderDiscountAmount,
                orderDiscountPercentage,
                createdAt,
                updatedAt,
            },
            canCancelOrder,
            availableStatusChanges {
                publicId,
                orderStatusName
            },
        }
    }
`;

export const SINGLE_WAREHOUSE_ORDER = gql`
    query SINGLE_WAREHOUSE_ORDER($id: String!, $authToken: String!){
        unauthenticatedOrder (id: $id, authToken: $authToken) {
            publicId,
            customer {
                name,
                phoneNumber,
                street
                institutionId {
                    name,
                    postalCode,
                    phoneNumber,
                },
            },
            deliveryDate,
            lpo,
            invoiceId,
            orderItems {
                publicId,
                item {
                    publicId,
                    productName,
                    code,
                    qpoUnit
                },
                itemCount
                shipments {
                    orderId
                },
            },
        }
    }
`;

export const ADD_NEW_ORDER = gql`
    mutation ADD_NEW_ORDER($customer: String!, $orderedBy: String!, $ignoreTimezoneLimit: Boolean, $orderTimezone: String!, $deliveryDate: Date!, $lpo: String, $items: [OrderItemInputType]){
        createOrder(customer: $customer, orderedBy: $orderedBy, ignoreTimezoneLimit: $ignoreTimezoneLimit, orderTimezone: $orderTimezone, deliveryDate: $deliveryDate ,lpo: $lpo, items: $items) {
            order {
                publicId
            }
        }
    }
`;

export const ADD_ITEM_TO_ORDER = gql`
    mutation ADD_ITEM_TO_SAMPLE_ORDER($order: String!, $itemId: String!, $itemCount: Int, $warehouseId: String){
        orderItem(order: $order, itemId: $itemId, itemCount: $itemCount, warehouseId: $warehouseId) {
            orderLineItem {
                publicId
            }
        }
    }
`;

export const UPDATE_ORDER_ITEM = gql`
    mutation UPDATE_SAMPLE_ORDER_ITEM($id: ID!, $order: String!, $itemId: String!, $itemCount: Int, $warehouseId: String, $shipments: [String], $status: String){
        orderItem(id: $id, order: $order, itemId: $itemId, itemCount: $itemCount, warehouseId: $warehouseId, shipments: $shipments, status: $status) {
            orderLineItem {
                publicId
            }
        }
    }
`;

export const DELETE_ITEM_FROM_ORDER = gql`
    mutation DELETE_ITEM_FROM_ORDER($id: ID!){
        deleteOrderItem(id: $id) {
            message
        }
    }
`;

export const CHECK_SINGLE_ORDER_VALIDITY = gql`
    query CHECK_SINGLE_ORDER_VALIDITY($id: String!){
        orderProcessingValidity(id: $id) {
            message
        }
    }
`;

export const CHANGE_ORDER_STATUS = gql`
    mutation CHANGE_ORDER_STATUS($orderId: String!, $statusId: String){
        changeOrderStatus(orderId: $orderId, statusId: $statusId) {
            message
        }
    }
`;

export const CHANGE_ORDER_PAYMENT_STATUS = gql`
    mutation CHANGE_ORDER_PAYMENT_STATUS($orderId: String!, $paymentStatus: Int, $paymentTypeId: String, $paymentRef: String, $paymentType: String, $amountPaid:String){
        changeOrderPaymentStatus(orderId: $orderId, paymentStatus: $paymentStatus, paymentTypeId: $paymentTypeId, paymentRef: $paymentRef, paymentType: $paymentType, amountPaid: $amountPaid) {
            message
        }
    }
`;

export const CREATE_ORDER_DEPOSIT = gql`
    mutation CREATE_ORDER_DEPOSIT($orderId: String!){
        depositOrderPayment(orderId: $orderId) {
            message
        }
    }
`;

export const ADD_SURCHARGE_TO_ORDER = gql`
    mutation ADD_SURCHARGE_TO_ORDER($id: String!, $surcharge: Int){
        setSurcharge(id: $id, surcharge: $surcharge) {
            message
        }
    }
`;

export const DELETE_SURCHARGE_FROM_ORDER = gql`
    mutation DELETE_SURCHARGE_FROM_ORDER($id: String!){
        deleteSurcharge(id: $id) {
            message
        }
    }
`;

export const SEND_WAREHOUSE_EMAIL = gql`
    query SEND_WAREHOUSE_EMAIL{
        triggerWarehouseEmail{
            message
        }
    }
`;



export const ALL_PAYMENT_METHODS = gql`
    query ALL_PAYMENT_METHODS($page: Int!, $perPage: Int!, $searchKeyword: String){
        paymentMethods (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                paymentMethodName,
                paymentIsDeposit,
                createdAt,
                updatedAt,
                lastUpdatedBy {
                    publicId,
                    name
                }
            }
        }
    }
`;

export const ALL_SAMPLE_ORDERS = gql`
    query ALL_SAMPLE_ORDERS($page: Int!, $perPage: Int!, $searchKeyword: String, $orderStatus: [String], $deliveryDates: [Date], $isFuture: Boolean ){
        sampleOrders (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, status: $orderStatus, deliveryDates: $deliveryDates, isFuture: $isFuture) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                invoiceId,
                deliveryDate,
                orderedBy,
                status {
                    orderStatusName
                },
                orderItems {
                    publicId,
                },
                createdAt,
            }
        }
    }
`;

export const SINGLE_SAMPLE_ORDER = gql`
    query SINGLE_SAMPLE_ORDER($id: String!){
        sampleOrder (id: $id) {
            publicId,
            invoiceId,
            deliveryDate,
            orderedBy,
            sampleOrderTaker {
                name
            },
            customer {
                publicId,
                name
            },
            status {
                orderStatusName
                isOrderCompleteStatus,
                isOrderCancelledStatus,
            },
            orderItems {
                publicId,
                item {
                    publicId,
                    productName,
                    qpoUnit
                    code
                },
                itemCount,
                grossItemTotal,
                removedFromStock
                shipment {
                    publicId,
                    orderId,
                    stockBalance,
                    createdAt
                }
            },
            grossOrderTotal,
            canCancelOrder
            createdAt,
            updatedAt,
            lastUpdatedBy {
                publicId,
                name
            }
            availableStatusChanges {
                publicId,
                orderStatusName
            },
        }
    }
`;

export const SINGLE_WAREHOUSE_SAMPLE_ORDER = gql`
    query SINGLE_WAREHOUSE_SAMPLE_ORDER($id: String!, $authToken: String!){
        unauthenticatedSampleOrder (id: $id, authToken: $authToken) {
            publicId,
            invoiceId,
            deliveryDate,
            orderItems {
                publicId,
                item {
                    publicId,
                    productName,
                },
                shipment {
                    orderId,
                }
                itemCount,
            },
        }
    }
`;

export const ADD_NEW_SAMPLE_ORDER = gql`
    mutation ADD_NEW_SAMPLE_ORDER($sampleOrderTaker: String!, $orderedBy: String!, $deliveryDate: Date!, $items: [SampleOrderItemInputType]){
        createSampleOrder(sampleOrderTaker: $sampleOrderTaker, orderedBy: $orderedBy, deliveryDate: $deliveryDate, items: $items) {
            sampleOrder {
                publicId
            }
        }
    }
`;

export const CREATE_CREDIT_NOTE = gql`
    mutation CREATE_CREDIT_NOTE($orderId: String!, $remarks: String!, $items: [CreditNoteItemInputType]){
        createCreditNote(orderId: $orderId, remarks: $remarks, items: $items) {
            creditNote {
                publicId
            }
        }
    }
`;

export const SINGLE_CREDIT_NOTE = gql`
    query SINGLE_CREDIT_NOTE($id: String!){
        creditNote (id: $id) {
            publicId,
            order {
                publicId,
                customer {
                    publicId,
                    name,
                    street,
                    institutionId {
                        name,
                        pin,
                        postalCode,
                        institutionCode,
                        phoneNumber,
                    },
                },
                deliveryDate,
                lpo,
                invoiceId,
                timezone {
                    timezoneName
                },
                orderedBy,
                paymentDueDate,
                status {
                    orderStatusName
                },
            },
            creditNoteItems {
                publicId,
                orderItem {
                    item {
                        code,
                        productName
                    },
                    shipments {
                        expiryDate
                    },
                    netItemPrice
                },
                itemCount,
                itemPieces,
                itemVat,
                netItemTotal,
                grossItemTotal
            },
            noteRef,
            remarks,
            creditNoteVat,
            creditNoteNetTotal,
            creditNoteGrossTotal
            createdAt,
            updatedAt,
            lastUpdatedBy {
                publicId,
                name
            }
        }
    }
`;

export const ALL_SAMPLE_ORDER_TAKERS = gql`
    query ALL_SAMPLE_ORDER_TAKERS($page: Int!, $perPage: Int!, $searchKeyword: String){
        sampleOrderTakers (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                name,
                description
            }
        }
    }
`;

export const ADD_ITEM_TO_SAMPLE_ORDER = gql`
    mutation ADD_ITEM_TO_SAMPLE_ORDER($sampleOrder: String!, $itemId: String!, $itemCount: Int, $shipmentId: String){
        sampleOrderItem(sampleOrder: $sampleOrder, itemId: $itemId, itemCount: $itemCount, shipmentId: $shipmentId) {
            message
        }
    }
`;

export const UPDATE_SAMPLE_ORDER_ITEM = gql`
    mutation UPDATE_SAMPLE_ORDER_ITEM($id: ID!, $sampleOrder: String!, $itemId: String!, $itemCount: Int, $shipmentId: String){
        sampleOrderItem(id: $id, sampleOrder: $sampleOrder, itemId: $itemId, itemCount: $itemCount, shipmentId: $shipmentId) {
            message
        }
    }
`;

export const DELETE_ITEM_FROM_SAMPLE_ORDER = gql`
    mutation DELETE_ITEM_FROM_SAMPLE_ORDER($id: ID!){
        deleteSampleOrderItem(id: $id) {
            message
        }
    }
`;

export const CHANGE_SAMPLE_ORDER_STATUS = gql`
    mutation CHANGE_SAMPLE_ORDER_STATUS($sampleOrderId: String!, $statusId: String){
        changeSampleOrderStatus(sampleOrderId: $sampleOrderId, statusId: $statusId) {
            message
        }
    }
`;

export const CHANGE_ORDER_DELIVERY_DATE = gql`
    mutation CHANGE_ORDER_DELIVERY_DATE($id: ID!,$newDate: Date!, $isOrder: Boolean!){
        changeDeliveryDate(id: $id, newDate: $newDate, isOrder: $isOrder) {
            message
        }
    }
`;

export const CHECK_ORDER_AVAILABLE_TIMEZONES = gql`
    query CHECK_ORDER_AVAILABLE_TIMEZONES($deliveryDate: Date!,$lat: Float!, $long: Float!, $branchId: String!){
        availableTimezones(deliveryDate: $deliveryDate, lat: $lat, long: $long, branchId: $branchId) {
            publicId,
            timezoneName,
            timezoneStartTime,
            timezoneEndTime
        }
    }
`;

export const ADD_ITEM_ORDER_DISCOUNT = gql`
    mutation ADD_ITEM_ORDER_DISCOUNT($orderItemId: String!, $discountAmount: Int, $discountPercentage: Int){
        itemDiscount(orderItemId: $orderItemId, discountAmount: $discountAmount, discountPercentage: $discountPercentage) {
            message
        }
    }
`;

export const UPDATE_ITEM_ORDER_DISCOUNT = gql`
    mutation UPDATE_ITEM_ORDER_DISCOUNT($id: ID!, $orderItemId: String!, $discountAmount: Int, $discountPercentage: Int){
        itemDiscount(id: $id, orderItemId: $orderItemId, discountAmount: $discountAmount, discountPercentage: $discountPercentage) {
            message
        }
    }
`;

export const DELETE_ITEM_ORDER_DISCOUNT = gql`
    mutation DELETE_ITEM_ORDER_DISCOUNT($id: ID!){
        deleteItemDiscount(id: $id) {
            message
        }
    }
`;

export const ADD_ORDER_DISCOUNT = gql`
    mutation ADD_ORDER_DISCOUNT($orderId: String!, $discountAmount: Int, $discountPercentage: Int){
        orderDiscount(orderId: $orderId, discountAmount: $discountAmount, discountPercentage: $discountPercentage) {
            message
        }
    }
`;

export const UPDATE_ORDER_DISCOUNT = gql`
    mutation UPDATE_ORDER_DISCOUNT($id: ID!, $orderId: String!, $discountAmount: Int, $discountPercentage: Int){
        orderDiscount(id: $id, orderId: $orderId, discountAmount: $discountAmount, discountPercentage: $discountPercentage) {
            message
        }
    }
`;

export const DELETE_ORDER_DISCOUNT = gql`
    mutation DELETE_ORDER_DISCOUNT($id: ID!){
        deleteOrderDiscount(id: $id) {
            message
        }
    }
`;

export const ALL_CREDIT_NOTES = gql`
    query ALL_CREDIT_NOTES($page: Int!, $perPage: Int!, $searchKeyword: String){
        creditNotes (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                order {
                    publicId,
                    customer {
                        publicId,
                        name,
                        lat
                        longi
                    },
                    deliveryDate,
                    lpo,
                    invoiceId
                },
                noteRef,
                remarks,
                createdAt,
                updatedAt,
                lastUpdatedBy {
                    publicId,
                    name
                }
            }
        }
    }
`;
